{
  "en": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Yes, delete",
        "text": "Do you really want to delete \"{filename}\"? The file and its searchable curriculum content will be removed.",
        "title": "Delete curriculum?"
      },
      "configure": "Open curriculum settings",
      "contextPanel": {
        "loadFailed": "The curricula could not be loaded right now. Try again later.",
        "manage": "Manage your own curricula",
        "matching": "These curricula match the school details above.",
        "noSubject": "Select a subject above, then we'll show you matching curricula.",
        "noSubjectMatch": "We don't have any curricula for the selected subject. Upload your own, and the AI will use it.",
        "none": "We don't have a curriculum for these details yet. Upload your own, and the AI will use it.",
        "notFound": "We couldn't find a matching curriculum for the details above in {place}. Upload your own, and the AI will use it.",
        "ownDocument": "Own document",
        "title": "Curricula",
        "unknownRegion": "We don't know your federal state. To prevent the AI from using a wrong curriculum, it won't use one. Add your federal state in your profile.",
        "used": "This material is based on these curricula.",
        "usedIn": "This material is based on these curricula for {place}."
      },
      "coverage": {
        "grades": "Grade {range}",
        "heading": "Your subjects in {place}",
        "headingWithoutPlace": "Your subjects",
        "openProfile": "Open profile",
        "profileIncomplete": "Add your subjects, school type, and grade levels to your profile, and we'll show you the matching curricula here.",
        "unmapped": "There is no curriculum for {labels}. Upload your own, and the AI will use it.",
        "editProfile": "Edit Profile",
        "own": "Own",
        "none": "No curriculum for {place}",
        "noneOtherRegions": "No curriculum for {place}, only for other federal states",
        "uploadHint": "Upload your own below.",
        "more": "and {count} more"
      },
      "delete": "Delete curriculum",
      "deleted": "Curriculum was deleted.",
      "deleteFailed": "Curriculum could not be deleted.",
      "empty": "No personal curriculum documents have been uploaded yet.",
      "fields": {
        "country": "Country",
        "gradeLevel": "Grade level",
        "region": "Region",
        "schoolType": "School type",
        "subject": "Subject",
        "title": "Title"
      },
      "intro": "We use the official curricula from Germany, Austria and Switzerland. You can also upload your own curriculum documents, for example a school-internal curriculum. If there is a custom curriculum for a subject, the AI will follow it first.",
      "loading": "Loading curricula...",
      "notSet": "Not set",
      "placeholders": {
        "selectOrAddOptions": "Search, select, or enter your own value"
      },
      "saved": "Curriculum metadata saved.",
      "title": "Curricula",
      "upload": "Upload curriculum",
      "uploaded": "Curriculum was uploaded and is being processed.",
      "uploadFailed": "Curriculum could not be uploaded.",
      "library": {
        "title": "Curricula",
        "subtitle": "What does the curriculum prescribe for your lessons? Select country, school type, subject and grade level or search directly for a topic.",
        "search": {
          "label": "Search curricula",
          "placeholder": "Search topic, term or competency…",
          "submit": "Search",
          "clear": "End search",
          "resultsTitle": "{count} result for “{query}” | {count} results for “{query}”",
          "noResultsTitle": "No results for “{query}”",
          "noResultsText": "Try a different term or remove subject and grade filters.",
          "loadFailed": "The search did not work. Please try again.",
          "examplesLabel": "For example:",
          "examples": "Evolution, Ecosystem, Quadratic functions, Particle model, Hormones"
        },
        "filters": {
          "country": "Country",
          "region": "Federal state",
          "regionCh": "Canton",
          "allRegions": "All regions",
          "schoolType": "School type",
          "allSchoolTypes": "All school types",
          "subject": "Subject",
          "allSubjects": "All subjects",
          "yourSubjects": "Your subjects",
          "otherSubjects": "More subjects",
          "subjectSearch": "Search subject…",
          "noDocuments": "none yet",
          "editProfile": "Edit profile",
          "fromProfileFrame": "Preselected from your profile: {frame}."
        },
        "grades": {
          "title": "Grade level",
          "hint": "The bars show how many curricula exist per level.",
          "selected": "Only grade {grade}",
          "showAll": "Show all",
          "gradeLabel": "Grade {grade}, {count} curriculum | Grade {grade}, {count} curricula",
          "primary": "Primary school 1–4",
          "secondaryOne": "Lower secondary 5–10",
          "secondaryTwo": "Upper secondary 11–13",
          "short": "Grade"
        },
        "list": {
          "count": "{count} curriculum | {count} curricula",
          "read": "Read",
          "loadFailed": "The curricula could not be loaded. Please try again."
        },
        "empty": {
          "regionTitle": "We don't have curricula for {place} yet",
          "regionText": "We are gradually adding all countries. You can already upload your school's curriculum in the AI Chat and use it there.",
          "filterTitle": "No curricula for this selection",
          "filterText": "Remove a filter or select a different grade level.",
          "unknownFilter": "We don't recognize this selection. Please select again."
        },
        "reader": {
          "back": "Curricula",
          "original": "Open original",
          "contents": "Content",
          "find": "Search within this curriculum…",
          "findLabel": "Search within this curriculum",
          "matches": "{count} section | {count} sections",
          "otherGrades": "In other grade levels:",
          "hours": "approx. {hours} hrs",
          "verbatim": "Wording from the official curriculum",
          "lostTable": "The original contains a table whose content could not be transferred. Please refer to the original.",
          "notFound": "This curriculum does not exist or is no longer available.",
          "chapterTruncated": "This chapter is very long and has been shortened here. You can find the full text in the original.",
          "textFailed": "The text of this curriculum could not be loaded. Reload the page to try again.",
          "chapterFailed": "This chapter could not be loaded.",
          "retry": "Try again"
        }
      },
      "ownDocumentsHeading": "Your own curricula",
      "processing": "Processing … the categories will appear here shortly.",
      "ready": "Ready",
      "failed": "Could not be processed.",
      "retry": "Try again",
      "retryFailed": "Processing could not be restarted."
    }
  }
}
